import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Stars } from "@/components/Stars";

export function NotificationBell() {
  const [data, setData] = useState({ count: 0, items: [] });
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const load = () => api.get("/pro/notifications").then((r) => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    window.addEventListener("qfq:notif-refresh", load);
    return () => {
      clearInterval(t);
      window.removeEventListener("qfq:notif-refresh", load);
    };
  }, []);
  if (!data.count) return null;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="relative rounded-full p-2 text-slate-700 hover:bg-slate-100" aria-label="Nouveaux avis" data-testid="notif-bell-button">
          <Bell className="h-5 w-5" />
          <span className="absolute -right-0.5 -top-0.5 grid h-5 min-w-[20px] place-items-center rounded-full bg-[#D97706] px-1 text-[11px] font-bold text-white" data-testid="notif-count">{data.count}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="z-[1100] w-80 p-0" data-testid="notif-panel">
        <p className="border-b border-slate-100 px-4 py-3 text-sm font-semibold">Nouveaux avis sur vos fiches</p>
        <ul className="max-h-80 overflow-auto">
          {data.items.map((n) => (
            <li key={n.id}>
              <Link to={`/mon-espace?onglet=avis&entreprise=${n.business_id}`} onClick={() => setOpen(false)} className="block px-4 py-3 text-sm hover:bg-slate-50" data-testid={`notif-item-${n.id}`}>
                <span className="flex items-center justify-between gap-2"><b className="truncate">{n.author}</b><Stars value={n.rating} size="h-3.5 w-3.5" /></span>
                <span className="block truncate text-xs text-slate-500">{n.business_name} · {new Date(n.created_at).toLocaleDateString("fr-FR")}</span>
              </Link>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
